import { FlowKind } from 'flow-schema';

export const FLOW_KIND_CONSTANTS: Record<
  FlowKind,
  { label: string; pluralLabel: string; basePath: string }
> = {
  [FlowKind.Base]: {
    label: 'Flow',
    pluralLabel: 'Flows',
    basePath: '/agents/flows',
  },
  [FlowKind.Skill]: {
    label: 'Skill',
    pluralLabel: 'Skills',
    basePath: '/agents/skills',
  },
  [FlowKind.FlowTemplate]: {
    label: 'Flow Template',
    pluralLabel: 'Flow Templates',
    basePath: '/agents/flows/create',
  },
};
